import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  HireTouchDubaiIcon,
  HireReqDubaiIcon,
  HireAssembleDubaiIcon,
  HireOnboardingDubaiIcon,
  HireScaleDubaiIcon,
} from "../../../app-constants";
import HtmlParser from "react-html-parser";

const process = [
  {
    number: "01",
    title: `Get<br/> In Touch`,
    txt: `<p>Fill the contact form and sign an NDA document Schedule a meeting with our experts to discuss your requirements</p>`,
    icon: HireTouchDubaiIcon,
  },
  {
    number: "02",
    title: `Requirement<br /> Analysis`,
    txt: `<p> Share your goals and challenges with our experts for a comprehensive analysis Receive expert consultation to determine the best approach for your project</p>`,
    icon: HireReqDubaiIcon,
  },
  {
    number: "03",
    title: `Assemble<br /> Team`,
    txt: ` <ul><li>Choose the talent required</li>
    <li>Meet professionals in-person</li>
    <li>Get a team of developers assembled</li>
  </ul>`,
    icon: HireAssembleDubaiIcon,
  },
  {
    number: "04",
    title: ` Successful<br />Onboarding`,
    txt: ` <ul>
    <li>Scope of tasks shared with hired experts</li>
    <li>Experts start with the development process</li>
    <li>1:1 communication to keep you updated at every step</li>
  </ul>`,
    icon: HireOnboardingDubaiIcon,
  },
  {
    number: "05",
    title: `  Scale Up or<br />Down`,
    txt: ` <ul>
    <li>Not Happy? Choose another expert</li>
    <li>Need to scale up? Hire More Developers</li>
    <li>Done with the major task? Reduce your team size</li>
  </ul>`,
    icon: HireScaleDubaiIcon,
  },
];

function Simplifiedprocess() {
  return (
    <div className="simplified_process p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Our Simplified Process To Hire Mobile App Developers In Dubai
            </h2>
            <p>
              Experience complete transparency and support throughout the hiring
              process with our simplified approach.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="process_main">
              {process.map((item, index) => (
                <div className="process_box_mob">
                  <div className="step_num">{item.number}</div>
                  <div className="process_flex">
                    <div className="process_box_head">
                      <strong>STEP {index + 1}</strong>
                      <h5>{HtmlParser(item.title)}</h5>
                    </div>
                    <div className="process_box_img">{item.icon}</div>
                  </div>
                  <div className="process_box_mob_content">
                    {HtmlParser(item.txt)}
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Simplifiedprocess;
